export const Constants = {
  TAG_NAME: 'pop-state-diversification-table-component',
  STATE_COLUMN_HEADER: 'State',
  PERCENT_OF_PORTFOLIO_COLUMN_HEADER: '% of portfolio',
  PERCENT_CHANGE_FROM_LAST_PERIOD_COLUMN_HEADER:
    '% change from previous period',
  STATE_COLUMN_ID: 'state',
  PERCENT_OF_PORTFOLIO_COLUMN_ID: 'percent-of-portfolio',
  PERCENT_CHANGE_COLUMN_ID: 'percent-change',
  EMPTY_CELL_VALUE: 'N/A',
  SORT_LABEL: 'sort',
  SORT_EVENT: 'pop-state-diversification-sort',
  ASCENDING_LABEL: 'ascending',
  DESCENDING_LABEL: 'descending',
  RIGHT_ALIGN: 'right-align',
  SORTED: 'sorted',
} as const;
